import introJs from "intro.js";

import * as Intro from './_IntroBase';

export function partnerTabStartIntro() {
    partnerTabInitSteps();

    introJs()
        .setOption('exitOnOverlayClick', 'false')
        .setOption('prevLabel', 'Előző')
        .setOption('nextLabel', 'Következő')
        .setOption('skipLabel', 'x')
        .setOption('doneLabel', 'x')
        .setOption('showBullets', false)
        .onexit(function () {
            window.SettingsManager.setAttribute('partnerTabIntro', true);
        })
        .start();
}

function partnerTabInitSteps() {
    let $table = $('#listErintettekItemModel_DXMainTable');
    let $excelExportButton = $('#listErintettekItemModel_DXCTMenu0_DXI0_T');

    // (1/4) Információ gomb
    Intro.initFirstStepTemplateHeader($('#partner-tab-intro'), 4);

    // (2/4) Új oszlop
    $table.attr('data-step', 2);
    $table.attr('data-intro', Intro.introTemplateHeader('Új oszlop', 2, 4) + 'Feltüntettük az oldalon az Érintettek Kapcsolattartási módját.');

    // (3/4) Excel export
    $excelExportButton.attr('data-step', 3);
    $excelExportButton.attr('data-intro', Intro.introTemplateHeader('Excel export', 3, 4) + 'Az Érintettek táblázat tartalmát excel fájlban le lehet tölteni.');

    // (4/4) Elköszönés
    Intro.initLastStepTemplateHeader($('#listErintettekItemModel'), 4);
}

export function addPartnerStartIntro() {
    addPartnerInitSteps();

    introJs()
        .setOption('exitOnOverlayClick', 'false')
        .setOption('prevLabel', 'Előző')
        .setOption('nextLabel', 'Következő')
        .setOption('skipLabel', 'x')
        .setOption('doneLabel', 'x')
        .setOption('showBullets', false)
        .onexit(function () {
            $('#uploadedDocs .dxgvCSD').css('height', 'unset');
            $('#uploadedDocs .dxgvCSD').css('overflow', 'hidden scroll');

            window.SettingsManager.setAttribute('addPartnerStartIntro', true);
        })
        .start();
}

function addPartnerInitSteps() {
    let $introStartButton = $('#add-partner-intro');
    $introStartButton.attr('data-step', 1);
    $introStartButton.attr('data-intro', Intro.introTemplateHeader('Információ gomb', 1, 4) + 'Köszöntjük a megújult oldalon! A következőkben végig kalauzoljuk az újdonságokon. Ha nem szeretné most megnézni, kattintson a jobb felső sarokban található "X" gombra, a későbbiekben is bármikor megnézheti a bemutatót, erre a zöld i ikonra kattintva.')

    let $type = $('#Type');
    $type.attr('data-step', 2);
    $type.attr('data-intro', Intro.introTemplateHeader('Típus', 2, 4) + 'Két új típus lett elérhető: „Polgármester” és „Szolgalmi jog jogosult”. Valamint a lista tetejére került a 6 leggyakrabban használt elem, mely után "ABC" sorrendben következnek az elemek.');

    let $mothersName = $('div.personal-data-mother');
    $mothersName.attr('data-step', 3);
    $mothersName.attr('data-intro', Intro.introTemplateHeader('Kötelező mezők', 3, 4) + 'Több kötelező kitöltendő mező van a "Kérelmező (Építtető), Tervező, Tulajdonos, Építési műszaki ellenőr, Építtető, Felelős műszaki vezető, Kivitelező, Kötelezett, Tervezői művezető" típusú érintetteknél. Természetes személyeknél a születési adatok, anyja neve. Jogi személynél az adószám és cégjegyzékszám.');

    Intro.initLastStepTemplateHeader($('div.personal-data-mother > table.form'), 4);
}
